// Simple API client for organization operations
// The actual business logic is in /backend_auth/services/organizationService.js
import { API_BASE_URL } from '../config';
 
const AUTH_API_BASE_URL = API_BASE_URL;

export const organizationsAPI = {
  /**
   * Get the current user's organization (alias for getUserOrganization)
   */
  async getUserOrganization(authToken = null) {
    return this.getMyOrganization(authToken);
  },

  /**
   * Get the current user's organization
   */
  async getMyOrganization(authToken = null) {
    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${AUTH_API_BASE_URL}/api/organizations/me`, { headers });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      const errorMessage = errorData.details || errorData.error || 'Failed to fetch organization';
      throw new Error(errorMessage);
    }

    return await response.json();
  },

  /**
   * Create a new organization
   */
  async createOrganization(organizationData, authToken) {
    const headers = {
      'Content-Type': 'application/json',
    };
    
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${AUTH_API_BASE_URL}/api/organizations`, {
      method: 'POST',
      headers,
      body: JSON.stringify(organizationData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      const errorMessage = errorData.details || errorData.error || 'Failed to create organization';
      throw new Error(errorMessage);
    }

    return await response.json();
  },

  /**
   * Update organization information
   */
  async updateOrganization(organization_id, updateData, authToken) {
    const headers = {
      'Content-Type': 'application/json',
    };
    
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${AUTH_API_BASE_URL}/api/organizations/${organization_id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      const errorMessage = errorData.details || errorData.error || 'Failed to update organization';
      throw new Error(errorMessage);
    }

    return await response.json();
  },

  /**
   * Delete organization
   */
  async deleteOrganization(organization_id, authToken) {
    const headers = {
      'Content-Type': 'application/json',
    };
    
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${AUTH_API_BASE_URL}/api/organizations/${organization_id}`, {
      method: 'DELETE',
      headers
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error occurred' }));
      const errorMessage = errorData.details || errorData.error || `Failed to delete organization (${response.status})`;
      throw new Error(errorMessage);
    }

    return await response.json();
  }
};

// Export as default for backward compatibility
export default organizationsAPI;
